
import { defineComponent, reactive, onMounted, toRefs, computed } from 'vue'
import f10ApiHk from '@/api/f10ApiHk'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import { useRoute } from 'vue-router'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => ({})
    },
    token: {
      type: String,
      default: ''
    }
  },
  components: { Table, Nodata },

  setup(props) {
    const route = useRoute()
    const pageData = reactive({
      data: [] as any[],
      columns: [
        {
          title: '变动日期',
          dataIndex: 'formattedDate',
          key: 'formattedDate',
          width: '120px',
          align: 'left'
        },
        {
          title: '总股本',
          dataIndex: 'formattedShares',
          key: 'formattedShares',
          width: '120px',
          align: 'right'
        },
        {
          title: '变动原因',
          dataIndex: 'chgReasonExplain',
          key: 'chgReasonExplain',
          width: '200px',
          align: 'right'
        }
      ],
      spinning: true,
      // 分页相关配置
      currentPage: 1,
      pageSize: 10,
      total: 0
    })

    // 计算分页配置
    const paginationConfig = computed(() => {
      return {
        current: pageData.currentPage,
        pageSize: pageData.pageSize,
        total: pageData.total,
        showSizeChanger: true,
        // showQuickJumper: true,
        showTotal: (total: number, range: [number, number]) =>
          `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: (page: number, size: number) => {
          pageData.currentPage = page
          pageData.pageSize = size
        },
        onShowSizeChange: (current: number, size: number) => {
          pageData.currentPage = 1
          pageData.pageSize = size
        }
      }
    })

    onMounted(() => {
      const data = {
        data: {
          // market: 'HK',
          // symbol: '00700'
          market: route.query.market || 'HK',
          symbol: route.query.code || '00700',
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
        }
      }

      f10ApiHk.getBriefsharesList(data).then((res: any) => {
        if (res.data && res.data.list) {
          // 处理数据：格式化日期和股本数量
          const processedData = res.data.list.map((item: any) => {
            const date = new Date(item.chgDate)
            const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
              .toString()
              .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`

            // 转换为亿股单位，保留两位小数
            const formattedShares = (item.totalShares / 100000000).toFixed(2) + '亿'

            return {
              ...item,
              formattedDate,
              formattedShares
            }
          })

          // 设置数据总数
          pageData.data = processedData
          pageData.total = processedData.length
        }
        pageData.spinning = false
      }).catch(() => {
        pageData.spinning = false
      })
    })

    return {
      ...toRefs(pageData),
      paginationConfig
    }
  }
})
